import { InputBase, IconButton, Slider, Typography } from "@mui/material";
import { GiftCardInfoData } from "../../data/shared";
import EditPencilIcon from "../../icons/EditPencilIcon";
import { useEffect, useRef } from "react";
import numeral from "numeral";
import { formatMoney } from "../../helper/numberFormat";

type AmountSliderViewProps = {
  gift: GiftCardInfoData;
  voucherValue: number;
  onChange: (value: any) => void;
};
export const AmountSliderView = ({ gift, voucherValue, onChange }: AmountSliderViewProps) => {
  const inputRef = useRef<HTMLElement>(null);

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <InputBase
          inputRef={inputRef}
          value={voucherValue}
          onChange={(e) => {
            var value: any = e.target.value;
            if (isNaN(value)) {
              onChange(gift.minAmount);
              return;
            }

            var temp = parseFloat(value);
            if (temp > gift.maxAmount) return;
            onChange(value);
          }}
          sx={{ fontSize: "1.875rem", fontWeight: 700, width: "auto" }}
          fullWidth={false}
          startAdornment={<span style={{ fontSize: "1.875rem", fontWeight: 700, marginRight: "0.1875rem" }}>{gift.currency}</span>}
        />
        <IconButton
          onClick={() => {
            inputRef.current?.focus();
          }}
        >
          <EditPencilIcon />
        </IconButton>
      </div>
      <div>
        <Slider color="secondary" size="small" value={voucherValue} onChange={(e, value) => onChange(value)} step={500} min={gift.minAmount} max={gift.maxAmount} />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Typography>{formatMoney(gift.minAmount, gift.currency)}</Typography>
          <Typography>{formatMoney(gift.maxAmount, gift.currency)}</Typography>
        </div>
      </div>
    </>
  );
};
